import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginImg from '../../images/login1.png'
import { FiX } from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  backendApi,
  re,
  emailValidation,
  urlPattern,
  phNum,
} from "../../api/apiService";
import Loading from "../../images/loading.gif";

export default function Signup() {
  const [userName, setUsername] = useState("");
  const [addOrganizationView, setAddOrganizationView] = useState(false);
  const [addUserView, setAddUserView] = useState(false);
  const navigate = useNavigate();
  const [regions, setRegions] = useState([]);
  const [orgName, setOrgName] = useState("");
  const [orgAddress, setOrgAddress] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgContact, setOrgContact] = useState("");
  const [orgMobile, setOrgMobile] = useState("");
  const [orgType, setOrgType] = useState("");
  const [orgRegion, setOrgRegion] = useState("");
  const [orgZip, setOrgZip] = useState("");
  const [orgUrl, setOrgUrl] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [isloading, setIsloading] = useState(false);

  const companyTypes = [
    "IT",
    "Product",
    "Consulting",
    "Enterprise",
    "Financial Services",
    "Healthcare",
    "Manufacturing",
    "Retail",
    "Media and Entertainment",
    "Education",
    "Transportation",
    "Nonprofit Organization",
    "Government Agency",
  ];

  const handleMobilePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text/plain");

    // Use a regular expression to check if the pasted text contains only numbers
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  };

  const Signup = (e) => {
    e.preventDefault();
    if (userName === "") {
      toast.warn("Please enter your Email ID", { containerId: "D" });
      return false;
    } else if (!userName.match(emailValidation)) {
      toast.warn("Kindly enter a valid email-Id", { containerId: "D" });
      return false;
    } else if (!re.test(userName)) {
      toast.warn("Enter Valid Organization Email-Id please", {
        containerId: "D",
      });
      return false;
    }
    setIsloading(true);
    var req = {
      functionName: "registration",
      email_id: userName,
    };
    backendApi(req)
      .then((response) => {
        console.log("responseSignup", response);
        if (response.success) {
          setRegions(response.regions);
          if (response.siteId == 0) {
            // toast.warn("Please register your organization first", {
            //   containerId: "D",
            // });
            setAddOrganizationView(true);
          } else if (response.siteId != 0 && response.userId == '0') {
            localStorage.setItem("siteId", response.siteId);
            setAddUserView(true);
          } else {
            toast.error("Something went wrong!.Please try again later", {
              containerId: "D",
            });
          }
        } else {
          console.log("Error calling signup api");
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const Registration = (e) => {
    e.preventDefault();
    if (orgName.trim() === "") {
      toast.warn("Please enter your Company Name", { containerId: "D" });
      return false;
    } else if (orgAddress.trim() === "") {
      toast.warn("Please enter your Company Address", { containerId: "D" });
      return false;
    } else if (orgEmail.trim() === "") {
      toast.warn("Please enter your Company Email-Id", { containerId: "D" });
      return false;
    } else if (orgContact.trim() === "") {
      toast.warn("Please enter your Company Contact No:", { containerId: "D" });
      return false;
    } else if (orgMobile.trim() === "") {
      toast.warn("Please enter your Company Mobile No:", { containerId: "D" });
      return false;
    } else if (orgType === "") {
      toast.warn("Please select your Company type", { containerId: "D" });
      return false;
    } else if (orgRegion === "") {
      toast.warn("Please enter your Company Region", { containerId: "D" });
      return false;
    } else if (orgZip.trim() === "") {
      toast.warn("Please enter your Company Zipcode", { containerId: "D" });
      return false;
    } else if (orgUrl.trim() === "") {
      toast.warn("Please enter your Company Url", { containerId: "D" });
      return false;
    } else if (!re.test(orgEmail)) {
      toast.warn("Enter Valid Organization Email-Id please", {
        containerId: "D",
      });
      return false;
    } else if (!orgEmail.match(emailValidation)) {
      toast.warn("Kindly enter a valid email-Id", { containerId: "D" });
      return false;
    } else if (!urlPattern.test(orgUrl)) {
      toast.warn("Kindly enter a valid Website URL", { containerId: "D" });
      return false;
    } else if (!orgMobile.match(phNum)) {
      toast.warn("Mobile number must be 10 digits", { containerId: "D" });
      return false;
    }
    setIsloading(true)
    var req = {
      functionName: "registration_site",
      company_name: orgName,
      address: orgAddress,
      email_id: orgEmail,
      contact_no: orgContact,
      mobile_no: orgMobile,
      company_type: orgType,
      region_id: orgRegion,
      zip: orgZip,
      website_url: orgUrl,
    };
    console.log("registrationRequest", req);

    backendApi(req).then((response) => {
      console.log("responseRegistration", response);
      if (response.success) {
        toast.success(
          "Organization Registered succesfully.",
          { containerId: "D" }
        );
        localStorage.setItem("siteId", response.siteId);
        setAddOrganizationView(false);
        setAddUserView(true);
      } else {
        console.log("Error calling registration api");
      }
    }).finally(()=>{
      setIsloading(false)
    });
  };

  const Cancel = () => {
    // navigate(-1);
    navigate('/', { state: {
      userPopup: true
    } });
  };

  const AddUser = (e) => {
    e.preventDefault();
    if (firstname.trim() === "") {
      toast.warn("Please enter first name", { containerId: "D" });
      return false;
    } else if (lastname.trim() === "") {
      toast.warn("Please enter last name", { containerId: "D" });
      return false;
    } else if (mobile.trim() === "") {
      toast.warn("Please enter mobile number", { containerId: "D" });
      return false;
    } else if (password.trim() === "") {
      toast.warn("Please enter password", { containerId: "D" });
      return false;
    } else if (password.trim().length < 8) {
      toast.warn("Password must be atleast 8 characters long", {
        containerId: "D",
      });
      return false;
    } else if (!mobile.match(phNum)) {
      toast.warn("Mobile number must be 10 digits", { containerId: "D" });
      return false;
    }
    setIsloading(true);
    var req = {
      functionName: "userRegistration",
      site_id: localStorage.getItem("siteId"),
      first_name: firstname,
      last_name: lastname,
      email_id: userName,
      mobile_no: mobile,
      password: password,
    };
    console.log("signupReq", req);

    backendApi(req)
      .then((response) => {
        console.log("responseSignup", response);
        if (response.success) {
          toast.success(
            "User registered succesfully.Please check your email for verification.",
            { containerId: "D" }
          );
          localStorage.setItem("userId", response.sec_user_id);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        } else {
          console.log("Error calling adduser api");
          toast.warn("Something went wrong !", { containerId: "D" });
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  return (
    <>
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
        {addUserView ? (
          <>
            <div className="login_popup">
    <div className="login_inner_popup">
    <FiX className="popup_close_div" 
    onClick={Cancel}
    />
        <div className="left_login_inner_popup">
            <div className="login_inner_svg">
                <img src={LoginImg} className="img-fluid" width="100%" height="100%"/>
            </div>
            
        </div>
        <div className="right_login_inner_popup">
            <div className="login_head">Signup</div>
            <div className="inner_login_container">
           <div className="login_form">
           <input type="text" className="login_input" 
           placeholder="EmailId"
           value={userName}
           readOnly
           />
           <input type="text" className="login_input" 
            placeholder="first name"
            value={firstname}
            onChange={(e) => setFirstName(e.target.value)}/>
           <input type="text" className="login_input" 
           placeholder="last name"
           value={lastname}
           onChange={(e) => setLastName(e.target.value)}/>
           <input type="text" className="login_input" 
            placeholder="mobile no:"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            onPaste={handleMobilePaste}
            onKeyDown={(event) => {
              const allowedKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
              ];
              if (
                event.ctrlKey &&
                (event.key === "a" ||
                  event.key === "c" ||
                  event.key === "v" ||
                  event.key === "x")
              ) {
                return;
              }
              if (
                !/^\d$/.test(event.key) &&
                !allowedKeys.includes(event.key)
              ) {
                event.preventDefault();
              }
            }}/>
            <input  className="login_input" 
            type={showPassword ? "text" : "password"}
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}/>
            <div className="d-flex align-items-center justify-content-between">
                    <a className="btn-cancel" onClick={Cancel}>
                    Back to Login
                  </a>
                  <a
                    className="login_btn"
                    onClick={AddUser}
                  >
                    {isloading ? (
                      <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      />
                    ) : (
                      "Signup"
                    )}
                  </a>
                </div>
           </div>
            </div>           
        </div>
    </div>
   </div>
          </>
        ) : addOrganizationView ? (
            <div className="login_popup">
    <div className="login_inner_popup">
    <FiX className="popup_close_div" 
     onClick={Cancel}/>
        <div className="left_login_inner_popup">
            <div className="login_inner_svg">
                <img src={LoginImg} className="img-fluid" width="100%" height="100%"/>
            </div>
            
        </div>
        <div className="right_login_inner_popup">
            <div className="login_head"> Register your Organization </div>
            <div className="inner_login_container">
           <div className="login_form">
           <input type="text" className="login_input" 
            placeholder="Organization Name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}/>
           <input type="text" className="login_input" 
            placeholder="Organization Address"
            value={orgAddress}
            onChange={(e) => setOrgAddress(e.target.value)}/>
           <input type="text" className="login_input" 
           placeholder="Organization Email-Id"
           value={orgEmail}
           onChange={(e) => setOrgEmail(e.target.value)}/>
           <input type="text" className="login_input" 
            placeholder="Mobile Number"
            value={orgMobile}
            onPaste={handleMobilePaste}
            onChange={(e) => setOrgMobile(e.target.value)}
            maxLength="10"
            onKeyDown={(event) => {
              const allowedKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
              ];
              if (
                event.ctrlKey &&
                (event.key === "a" ||
                  event.key === "c" ||
                  event.key === "v" ||
                  event.key === "x")
              ) {
                return;
              }
              if (
                !/^\d$/.test(event.key) &&
                !allowedKeys.includes(event.key)
              ) {
                event.preventDefault();
              }
            }}
           />
           <input type="text" className="login_input"
            placeholder="Contact No"
            value={orgContact}
            onPaste={handleMobilePaste}
            onChange={(e) => setOrgContact(e.target.value)}
            maxLength="10"
            onKeyDown={(event) => {
              const allowedKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
              ];
              if (
                event.ctrlKey &&
                (event.key === "a" ||
                  event.key === "c" ||
                  event.key === "v" ||
                  event.key === "x")
              ) {
                return;
              }
              if (
                !/^\d$/.test(event.key) &&
                !allowedKeys.includes(event.key)
              ) {
                event.preventDefault();
              }
            }}
           />
           <select
                  className="login_input"
                  value={orgType}
                  onChange={(e) => setOrgType(e.target.value)}
                >
                  <option value="">Select a Company type</option>
                  {companyTypes.map((companyType) => (
                    <option key={companyType} value={companyType}>
                      {companyType}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  onChange={(e) => setOrgRegion(e.target.value)}
                  value={orgRegion}
                >
                  <option value="">Select a Region</option>
                  {regions.map((region) => (
                    <option key={region.id} value={region.id}>
                      {region.region_name}
                    </option>
                  ))}
                </select>
            <input  className="login_input"
             type="text"
             placeholder="ZipCode"
             value={orgZip}
             onPaste={handleMobilePaste}
             onChange={(e) => setOrgZip(e.target.value)}
             onKeyDown={(event) => {
               const allowedKeys = [
                 "Backspace",
                 "ArrowLeft",
                 "ArrowRight",
                 "Delete",
                 "Tab",
               ];
               if (
                 event.ctrlKey &&
                 (event.key === "a" ||
                   event.key === "c" ||
                   event.key === "v" ||
                   event.key === "x")
               ) {
                 return;
               }
               if (
                 !/^\d$/.test(event.key) &&
                 !allowedKeys.includes(event.key)
               ) {
                 event.preventDefault();
               }
             }}/>
            <input type="text" className="login_input"
            placeholder="Website Url"
                  value={orgUrl}
                  onChange={(e) => setOrgUrl(e.target.value)}/>
            
            <div className="d-flex align-items-center justify-content-between">
                    <a
                    className="btn-cancel mt-1"
                    onClick={Cancel}
                  >
                    Cancel
                  </a>
                  <a
                    onClick={Registration}
                    className="login_btn"
                  >
                    {isloading ? (  <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      />):('Next')}
                  </a>
                </div>
           </div>
            </div>           
        </div>
    </div>
   </div>

        ) : (
          <>
          <div className="login_popup">
    <div className="login_inner_popup">
    <FiX className="popup_close_div" 
    onClick={Cancel}
    />
        <div className="left_login_inner_popup">
            <div className="login_inner_svg">
                <img src={LoginImg} className="img-fluid" width="100%" height="100%"/>
            </div>
            
        </div>
        <div className="right_login_inner_popup">
            <div className="login_head">Signup</div>
            <div className="inner_login_container">
           <div className="login_form">
           <input type="text" className="login_input" placeholder="Email-Id"
            value={userName}
            onChange={(e) => setUsername(e.target.value)}
           />
            <div className="d-flex align-items-center justify-content-between">

                    <a className="btn-cancel mt-1" onClick={Cancel}>
                    Back to Login
                  </a>
                  <a
                    onClick={Signup}
                    className="login_btn"
                  >
                    {isloading ? (
                      <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      />
                    ) : (
                      "Signup"
                    )}
                  </a>
                </div>
           </div>
            </div>           
        </div>
    </div>
   </div>
          </>
        )}
    </>
  );
}
